import React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { logout, resetVerifiedUser } from '../redux/actions'
import AjaxLoader from '../components/AjaxLoader'

class Logout extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            inProgress: true
        }
    }

    componentDidMount () {
        this.props.logout()
        this.props.resetVerifiedUser()

        this.interval = setInterval(() => {
            if (!this.props.isLoggedIn) {
                clearInterval(this.interval)
                this.setState({ inProgress: false })
            }
        }, 500)
    }

    componentWillUnmount () {
        clearInterval(this.interval)
    }

    render () {
        return this.state.inProgress ? <AjaxLoader /> : <Redirect to='/login' />
    }
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, { logout, resetVerifiedUser })(Logout)



// WEBPACK FOOTER //
// ./resources/js/auth/Logout.js